import React, { useState, useEffect } from "react";
import axios from "axios";
import { useUserContext } from "../../../contexts/UserContext";

export default function ChargeEditModal({ open, charge, onClose, onUpdated }) {
  const { getAuthHeaders } = useUserContext();

  const [form, setForm] = useState({
    description: "",
    categorie: "Autres",
    customCategorie: "",
    montantTTC: "",
    modePaiement: "Espèces",
    dateDepense: "",
    statut: "Payée",
    preuvePDF: null,
    removePDF: false, // nouveau champ pour suppression
  });

  useEffect(() => {
    if (charge) {
      setForm({
        description: charge.description || "",
        categorie: charge.categorie || "Autres",
        customCategorie: "",
        montantTTC: charge.montantTTC || "",
        modePaiement: charge.modePaiement || "Espèces",
        dateDepense: charge.dateDepense?.split("T")[0] || "",
        statut: charge.statut || "Payée",
        preuvePDF: null,
        removePDF: false,
      });
    }
  }, [charge]);

  if (!open || !charge) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const data = new FormData();

      const finalCategorie =
        form.categorie === "__custom__"
          ? form.customCategorie
          : form.categorie;

      data.append("categorie", finalCategorie);
      data.append("description", form.description);
      data.append("montantTTC", form.montantTTC);
      data.append("modePaiement", form.modePaiement);
      data.append("dateDepense", form.dateDepense);
      data.append("statut", form.statut);
      data.append("removePDF", form.removePDF); // informer le backend

      if (form.preuvePDF) {
        data.append("preuvePDF", form.preuvePDF);
      }

      const res = await axios.put(
        `http://localhost:4000/update/charges/${charge._id}`,
        data,
        {
          headers: getAuthHeaders(),
        }
      );

      onUpdated();
      onClose();
    } catch (err) {
      console.error("Erreur mise à jour charge", err);
      alert("Erreur mise à jour charge : " + err.response?.data?.message || err.message);
    }
  };

  return (
    <div className="modal-backdrop">
      <div className="modal-card glass">
        <h3>Modifier la charge</h3>

        <form onSubmit={handleSubmit} className="modal-form">
          <input
            placeholder="Description"
            value={form.description}
            onChange={(e) =>
              setForm({ ...form, description: e.target.value })
            }
            required
          />

          <label>Catégorie</label>
          <select
            value={form.categorie}
            onChange={(e) =>
              setForm({ ...form, categorie: e.target.value })
            }
          >
            {[
              "Loyer",
              "Eau",
              "Electricité",
              "Internet",
              "Transport",
              "Carburant",
              "Salaires",
              "Fournitures",
              "Maintenance",
              "Impôts",
              "Autres",
              "__custom__",
            ].map((cat) => (
              <option key={cat} value={cat}>
                {cat === "__custom__" ? "➕ Autre catégorie" : cat}
              </option>
            ))}
          </select>

          {form.categorie === "__custom__" && (
            <input
              placeholder="Nouvelle catégorie"
              value={form.customCategorie}
              onChange={(e) =>
                setForm({ ...form, customCategorie: e.target.value })
              }
              required
            />
          )}

          <input
            placeholder="Montant TTC"
            value={form.montantTTC}
            onChange={(e) =>
              setForm({ ...form, montantTTC: e.target.value })
            }
            required
          />

          <input
            type="date"
            value={form.dateDepense}
            onChange={(e) =>
              setForm({ ...form, dateDepense: e.target.value })
            }
          />

          <select
            value={form.modePaiement}
            onChange={(e) =>
              setForm({ ...form, modePaiement: e.target.value })
            }
          >
            {["Espèces", "Mobile Money", "Virement", "Chèque", "Carte"].map(
              (m) => (
                <option key={m} value={m}>
                  {m}
                </option>
              )
            )}
          </select>

          <select
            value={form.statut}
            onChange={(e) =>
              setForm({ ...form, statut: e.target.value })
            }
          >
            {["En attente", "Payée", "Annulée"].map((s) => (
              <option key={s} value={s}>
                {s}
              </option>
            ))}
          </select>

          {/* Affichage du PDF existant */}
          {/* {charge.preuvePDF && !form.removePDF && (
            <div style={{ marginBottom: "10px" }}>
              <a
                href={charge.preuvePDF}
                target="_blank"
                rel="noopener noreferrer"
              >
                📄 Voir le PDF actuel
              </a>
            </div>
          )} */}

          {/* Checkbox pour suppression */}
          {/* {charge.preuvePDF && (
            <div>
              <label>
                <input
                  type="checkbox"
                  checked={form.removePDF}
                  onChange={(e) =>
                    setForm({ ...form, removePDF: e.target.checked })
                  }
                />
                Supprimer le PDF existant
              </label>
            </div>
          )} */}

          {/* Upload nouveau PDF */}
          {/* <input
            type="file"
            accept="application/pdf"
            onChange={(e) =>
              setForm({ ...form, preuvePDF: e.target.files[0], removePDF: false })
            }
          /> */}

          <div className="modal-actions">
            <button type="submit" className="btn-primary">
              Mettre à jour
            </button>
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
            >
              Annuler
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}